import { useCallback } from 'react';
import { IFileItem } from '../types';

interface IUseBudgetFilesParams {
  files: IFileItem[];
  setFiles: React.Dispatch<React.SetStateAction<IFileItem[]>>;
  uploadFilesAction: (filesToUpload: File[], budgetIdToUse?: string) => Promise<boolean>;
}

export const useBudgetFiles = ({
  files,
  setFiles,
  uploadFilesAction,
}: IUseBudgetFilesParams) => {
  const handleFileClick = useCallback(
    (file: { name: string; type?: string; size?: string | number }, index: number) => {
      // Handler implementation if needed
    },
    [],
  );

  const handleFileRemove = useCallback((index: number) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  }, [setFiles]);

  const handleFilesAdd = useCallback((newFiles: IFileItem[]) => {
    setFiles((prev) => [...prev, ...newFiles]);
  }, [setFiles]);

  const collectFilesToUpload = useCallback((): File[] => {
    return files
      .filter((fileItem) => fileItem.file !== undefined)
      .map((fileItem) => fileItem.file as File);
  }, [files]);

  const uploadFilesIfNeeded = useCallback(
    async (action: string, budgetIdToUse?: string): Promise<boolean> => {
      const filesToUpload = collectFilesToUpload();
      return await uploadFilesAction(filesToUpload, budgetIdToUse);
    },
    [collectFilesToUpload, uploadFilesAction],
  );

  return {
    handleFileClick,
    handleFileRemove,
    handleFilesAdd,
    collectFilesToUpload,
    uploadFilesIfNeeded,
  };
};

